import { useMemo } from "react";

const useQueryParams = () => {

    const searchParams = useMemo(() => new URLSearchParams(window.location.search), [window.location.search]);
    const params = Object.fromEntries(searchParams.entries());
    return params
}

export default useQueryParams;